const DESTINATION_STAGES = {
    audio: 'audioStage',
    video: 'youtubeStage',
    apple: 'appleStage',
};

export function destinationStatusChanged(dataEl, episodes = {}) {
    if (!dataEl?.dataset || !episodes || typeof episodes !== 'object') return false;

    return Object.entries(DESTINATION_STAGES).some(([destination, datasetKey]) => {
        const displayedStage = dataEl.dataset[datasetKey] || '';
        const latestStage = episodes[destination]?.stage || '';

        return displayedStage !== latestStage;
    });
}

if (typeof window !== 'undefined') {
    window.CohostEpisodeStatusPolling = { destinationStatusChanged };
}
